import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { DeleteConfirmationComponent } from 'app/shared/components/delete-confirmation/delete-confirmation.component';
import { BzgModalService } from 'bz-genome-angular';

@Component({
  selector: 'biz-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent {
  public cellSpacingMode: string = 'normal';
  public orderDirection: string = 'asc';
  public orderColumnField: string = 'CreationDate';

  @Input() selectedTraces: Array<IBATraceFile> = [];
  @Input() traces: any = [];
  @Input() isCollapsed: boolean = false;
  @Input() isDownloading: boolean = false;
  @Input() isDeleting: boolean = false;
  @Input() isLastPage: boolean = false;

  @Output() emitSelectedDownload: EventEmitter<Array<string>> = new EventEmitter<Array<string>>();
  @Output() emitSelectedDeleted: EventEmitter<Array<string>> = new EventEmitter<Array<string>>();
  @Output() emitSelectedTrace: EventEmitter<IBATraceFile> = new EventEmitter<IBATraceFile>();
  @Output() emitLoadMoreResults: EventEmitter<number> = new EventEmitter<number>();

  constructor(private _modalService: BzgModalService, private elRef: ElementRef) { }

  ngAfterViewInit() {
    const checkHeaders = this.elRef.nativeElement.querySelectorAll('.bz-table-adv__header bzg-checkbox input[type="checkbox"]');
    if (checkHeaders)
      checkHeaders[0].addEventListener('click', this.onHeaderCheckboxClick.bind(this));
  }

  ngOnChanges() {
    if (this.selectedTraces.length === 0 && this.traces.length > 0)
      this.setFalse();
  }

  onHeaderCheckboxClick(event: Event) {
    const checkHeader = event.target as HTMLInputElement;
    const isChecked = checkHeader.checked;
    this.allTracesSelected(isChecked);
    this.selectedTraces = isChecked ? this.traces : [];
  }

  setFalse() {
    const allItemsSelected = this.traces.filter(trace => trace.selected === true);
    this.traces.forEach(trace => {
      trace.selected = false;
    });
    if (this.traces && this.traces.length && allItemsSelected && allItemsSelected.length === this.traces.length) {
      const checkHeaders = this.elRef.nativeElement.querySelectorAll('.bz-table-adv__header bzg-checkbox input[type="checkbox"]');
      checkHeaders.forEach((checkHeader: HTMLElement) => {
        checkHeader.click();
      });
    }
  }

  setSelectedTraces(traces) {
    this.selectedTraces = traces;
  }

  allTracesSelected(selectAllIsSelected) {
    this.traces.forEach(trace => {
      trace.selected = selectAllIsSelected;
    });
  }

  setClass() {
    return this.isCollapsed ? 'max-height-table' : 'min-height-table';
  }

  viewdetail(trace: IBATraceFile) {
    this.emitSelectedTrace.emit(trace);
  }

  loadMoreResults() {
    this.emitLoadMoreResults.emit(1);
  }

  downloadFile() {
    const selectedTracesNames = this.selectedTraces.map((trace) => trace.Name);
    this.emitSelectedDownload.emit(selectedTracesNames);
  }

  removeTraceFile() {
    const selectedTracesNames = this.selectedTraces.map((trace) => trace.Name);
    this.emitSelectedDeleted.emit(selectedTracesNames);
  }

  showConfirmDialog() {
    const modal = this._modalService.open(DeleteConfirmationComponent, {
      closeOnBackdropClick: false,
      closeOnRouterNavigation: true,
      data: {
        title: 'TRACE.DELETE_TITLE',
        message: 'TRACE.DELETE_CONFIRMATION'
      }
    });
    modal.afterClosed().subscribe((result: string) => {
      if (result === 'delete')
        this.removeTraceFile();
    })
  }
}
